import { useMemo } from 'react';
import { defineStepper } from '@hqo/multi-step-form';

export type StepperInstance = ReturnType<typeof useStepperInstance>;

const WHEN_STEP_FIELDS = [
  'visitStartDate',
  'visitEndDate',
  'startTime',
  'endTime',
  'duration',
  'useDuration',
  'repeatType',
  'repeatEndDate',
  'recurrenceDays',
  'isMultiDay',
  'visitDates',
];

const HOST_STEP_FIELDS = [
  'hostingType',
  'receiveInvitationCopy',
  'receiveCheckinNotifications',
  'additionalOrganizers',
  'floor',
  'suite',
  'hostEmail',
];

const VISIT_STEP_FIELDS = [
  'visitorMode',
  'visitSummary',
  'visitTypeId',
  'checkInInstructions',
  'noteForReception',
  'visitEntryOption',
  'acknowledgmentConfirmed',
  'email_opt_in',
  'sms_opt_in',
  'visitors',
];

/**
 * Hook that creates a stepper instance for the multi-step form
 */
export const useStepperInstance = ({
  skipVisitValidation,
  acknowledgmentRequired,
  includeHostStep = true,
}: { skipVisitValidation?: boolean; acknowledgmentRequired?: boolean; includeHostStep?: boolean } = {}) => {
  const visitFields = useMemo(() => {
    if (!skipVisitValidation) {
      return VISIT_STEP_FIELDS;
    }
    return acknowledgmentRequired ? ['acknowledgmentConfirmed'] : [];
  }, [skipVisitValidation, acknowledgmentRequired]);

  return useMemo(() => {
    const whenStep = {
      id: 'when',
      fields: WHEN_STEP_FIELDS,
    };
    const hostStep = {
      id: 'host',
      fields: HOST_STEP_FIELDS,
    };
    const visitStep = {
      id: 'visit',
      fields: visitFields,
    };

    return includeHostStep ? defineStepper(whenStep, hostStep, visitStep) : defineStepper(whenStep, visitStep);
  }, [visitFields, includeHostStep]);
};
